export default __webpack_public_path__ + "static/media/011-touch eyes.ab2a370d.svg";